module.exports = __webpack_public_path__ + "img/b9138baec0eb743ec366219cb10c477c.afc34806.png";